import Cookies from "js-cookie";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
  PaymentRequestButtonElement,
} from "@stripe/react-stripe-js";
import { isMobile } from "react-device-detect";
import price_changer from "../../data/price_change.json";
import pidPrice from "../../data/pid.json";
import membership from "../../data/weight_loss/changingWeiglossTests.json";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe(
  "pk_test_51HDCXXDM8fNsPiHl5YHgUPaWxr2xbCCZDzbqCxlDhfdnUojSsCiXj8vERAIlXk87yvOzOrPwkEGgbHvRfu54Xe6t00mkSmAAuH"
);

import { useRouter } from "next/router";
import { useState, useEffect } from "react";

import testVal from "../../data/test/tests.json";
import testVal1 from "../../data/test/inssurance.json";
import subcriptionTest from "../../data/subscriptions/subscriptions2.json";
import subcriptionTest1 from "../../data/subscriptions/insurance_subscription.json";
import subcriptionTest3 from "../../data/subscriptions/subscriptionsPid2.json";
import swal from "sweetalert";
import { upsellData } from "../../data/upsells/upsells.json";
import CrossSells from "../crossSells/crossSells";
import Subscriptions from "../subscription/subscriptions";
import { CloudinaryContext, Image } from 'cloudinary-react';
const CartBar1 = (props) => {
  const stripeOptions = {
    fonts: [
      {
        cssSrc: "https://fonts.googleapis.com/css2?family=Jost&display=swap",
        // family: "Montserrat",
      },
    ],
  };

  const [upsells, setUpsells] = useState(false);
  const [data, setData] = useState([]);
  const [test, setTest] = useState({
    price: 0,
    name: "",
  });
  const [upsell, setUpsell] = useState(null);
  const [firstCartName, setSetFirstCartName] = useState(null);
  const [activeIndex, setActiveIndex] = useState({ val: "" });
  const [mainTotal, setMainTotal] = useState(undefined);
  const [showCrossSell, setShowCrossSell] = useState(false);
  const [subscription, setSubscription] = useState(false);
  useEffect(() => {
    let price = 0;
    if (props.pid) {
      const findPriceChanger = price_changer.find((x) => x.pid == props.pid);
      const findPidChanger = pidPrice.find((x) => x.pid == props.pid);
      if (findPriceChanger && findPidChanger) {
        price = findPriceChanger.price;
      }
    }
    if (props.myCart.length) {
      let findSubData;

      let findOnetimeTest;
      if (props.variant == "insurance") {
        findSubData = subcriptionTest1.find(
          (x) =>
            x.testName.toLowerCase() == props.myCart[0].cartName.toLowerCase()
        );
        findOnetimeTest = testVal1.find(
          (x) =>
            x.testName.toLowerCase() == props.myCart[0].cartName.toLowerCase()
        );
      } else {
        if (props.pid) {
          findSubData = subcriptionTest.find(
            (x) =>
              x.testName.toLowerCase() == props.myCart[0].cartName.toLowerCase()
          );
        } else {
          findSubData = subcriptionTest3.find(
            (x) =>
              x.testName.toLowerCase() == props.myCart[0].cartName.toLowerCase()
          );
        }

        findOnetimeTest = testVal.find(
          (x) =>
            x.testName.toLowerCase() == props.myCart[0].cartName.toLowerCase()
        );
      }

      if (findSubData) {
        setData(findSubData.subscription);
        changePlan(findSubData.subscription[1], 21);
        setTest((test) => {
          return {
            ...test,
            price: findOnetimeTest.price + price,
            name: findOnetimeTest.testName,
          };
        });
      }
    }
  }, [props.myCart.length]);
  const router = useRouter();
  const closeCart = () => {
    props.closeCart == false
      ? router.push("/checkout")
      : props.setCloseCart(false);
    Cookies.remove("cart");
    Cookies.remove("totalPrice");
    Cookies.remove("discount");
    setUpsells(false);
    props.setPrice(0);
    props.myCart.length = 0;
    props.setCloseCart(false);
    FreshworksWidget("show");
  };
  const [prevPrice, setPrevPrice] = useState(null);
  useEffect(() => {
    if (props.myCart.length > 0 && props.myCart[0].cartType == "std") {
      setPrevPrice(props.myCart[0].cartPrice);
    }
    let price = Cookies.get("totalPrice");
    if (price && price != undefined) {
      props.setPrice(price);
    }
    let mainPrice = Cookies.get("mainPrice");
    if (mainPrice && mainPrice != undefined) {
      setMainTotal(mainPrice);
    }
  }, [props.myCart]);
  useEffect(() => {
    let cartName = "";
    if (props.myCart.length > 0) {
      cartName = props.myCart[0]?.cartName;
      setSetFirstCartName(cartName);
    }
    const csr = upsellData.find((x) => x.test == cartName);

    if (csr) {
      setUpsell(csr);
      setUpsells(true);
    } else {
      setUpsells(false);
    }
  }, [props.closeCart, !props.closeCart]);

  const gotTo = () => {
    if (
      props.myCart.length == 1 &&
      (props.myCart[0].cartName == "STD Standard" ||
        props.myCart[0].cartName == "STD Complete")
    ) {
      let stdData = {
        cartImg: "/chlamydia_&_gonorrhea.gif",
        cartName: "STD Basic",
        labFee: 300,
        cartPrice: 129,
      };
      Cookies.set("stdBasic", stdData);
    } else {
      Cookies.remove("stdBasic");
    }
    let findUpsells = props.myCart.find((x) => x && x.type == "upsells");
    if (!findUpsells) {
      Cookies.remove("discount");
    }
    Cookies.set("cart", props.myCart);
    if (props.price != 0 && props.myCart.length > 0) {
      Cookies.set("testImg", props.myCart[0].testImg);
      Cookies.set("isInsurance", props.insurance);
      router.push("/checkout");
    } else {
      swal("Please add a test for checkout");
      props.setCloseCart(false);
      FreshworksWidget("show");
      Cookies.remove("totalPrice", { path: "" });
      Cookies.remove("cart", { path: "" });
    }
  };

  const showDiscountPrice = (item) => {
    let totalPrice = parseInt(item.cartPrice);
    return parseInt((totalPrice / 100) * 30).toFixed(2);
  };
  const deleteUpsells = (ele) => {
    let removeProfit = 0;
    if (ele.profit != null) {
      removeProfit = parseInt(ele.profit);
    }
    const index = props.myCart.indexOf(ele);
    if (index > -1) {
      props.myCart.splice(index, 1);
      Cookies.set("cart", props.myCart);
      let totalPrice = 0;
      let upsells = false;
      let showTotal = 0;
      let benifit = 0;
      for (let i = 0; i < props.myCart.length; i++) {
        const element = props.myCart[i];
        if (element.profit != null && element.cartType != "weightloss") {
          totalPrice = parseInt(totalPrice) + parseInt(element.profit);
          showTotal = parseInt(showTotal) + parseInt(element.cartPrice);
          benifit = parseInt(benifit) + parseInt(element.profit);
        } else {
          totalPrice = parseInt(totalPrice) + parseInt(element.cartPrice);
          showTotal = parseInt(showTotal) + parseInt(element.cartPrice);
        }
      }
      setMainTotal(showTotal);
      props.setPrice(totalPrice);
      Cookies.set("totalPrice", totalPrice);
      Cookies.set("mainPrice", showTotal);
      Cookies.set("mainPrice", benifit);
      const findUpsells = props.myCart.find((x) => x.cartType == "upsells");
      if (findUpsells == undefined) {
        setMainTotal(undefined);
        Cookies.remove("mainPrice");
        Cookies.remove("discount");
      }
      if (props.myCart.length == 0) {
        Cookies.remove("cart");
        Cookies.remove("totalPrice");
        props.setCloseCart(false);
        FreshworksWidget("show");
        Cookies.remove("discount");
        setUpsells(false);
      }

      const find = props.myCart.find(
        (x) => x.cartType != "upsells" && x.cartType != "std_upsells"
      );
      if (find) {
      } else {
        Cookies.remove("cart");
        Cookies.remove("totalPrice");
        FreshworksWidget("show");
        Cookies.remove("discount");
        setUpsells(false);
        props.setPrice(0);
        props.myCart.length = 0;
        props.setCloseCart(false);
      }
    }
  };


  const [weightlossIndex, setWeightlossIndex] = useState(null);
  const upgradeTest = (element) => {
    props.myCart[0].cartName = element.cartName;
    props.myCart[0].cartImg = element.img;
    props.myCart[0].month = 1;
    let prev = parseInt(props.myCart[0].cartPrice);
    props.myCart[0].cartPrice = element.cartPrice;
    setPlan(21);
    let ttprice = parseInt(props.price) - parseInt(prev);
    let coolprice = ttprice + parseInt(element.cartPrice);
    props.setPrice(coolprice);
    Cookies.set("totalPrice", coolprice);
    Cookies.set("cart", props.myCart);
    if (mainTotal != undefined) {
      let loltotal = 0;
      for (let i = 0; i < props.myCart.length; i++) {
        const element = props.myCart[i];
        loltotal = parseInt(loltotal) + parseInt(element.cartPrice);
      }
      setMainTotal(loltotal);
      Cookies.set("mainPrice", loltotal);
    }
  };
  const deleteItem = (ele) => {
    if (
      props.myCart.length > 1 &&
      props.myCart[0].cartType == "allergy" &&
      (ele.cartName == "Indoor & Outdoor Allergy" ||
        ele.cartName == "36 Food Allergy Panel" ||
        ele.cartName == "Indoor and Outdoor Allergy" ||
        ele.cartName == "Celiac Complete")
    ) {
      const index = props.myCart.indexOf(ele);
      if (index > -1) {
        props.myCart.splice(index, 1);
        let totalPrice = 0;
        let benifit = 0;
        if (props.myCart.length > 0) {
          for (let i = 0; i < props.myCart.length; i++) {
            const element = props.myCart[i];
            if (i > 0) {
              totalPrice = totalPrice + parseInt(element.cartPrice);
              let cartAmount = parseInt(element.cartPrice);
              let cartPr = (cartAmount / 100) * 30;
              let cartProfit = cartAmount - cartPr;
              props.myCart[i].profit = cartProfit;
              benifit = benifit + cartPr;
            } else {
              totalPrice = totalPrice + parseInt(element.cartPrice);
              if (element.profit != null) {
                props.myCart[i].profit = 0;
              }
            }
          }
          setMainTotal(totalPrice);
          Cookies.set("mainPrice", totalPrice);
          Cookies.set("cart", props.myCart);
          Cookies.set("discount", benifit);
          let mainPrice = totalPrice - benifit;
          Cookies.set("totalPrice", mainPrice);
          props.setPrice(mainPrice);
          if (props.myCart.length == 1) {
            setMainTotal(undefined);
            Cookies.remove("mainPrice");
          }
        }
      } else {
        Cookies.remove("cart");
        Cookies.remove("totalPrice");
        props.setCloseCart(false);
        FreshworksWidget("show");
        setUpsells(false);
      }
    } else {
      const index = props.myCart.indexOf(ele);
      if (index > -1) {
        props.myCart.splice(index, 1);
        Cookies.set("cart", props.myCart);
        let totalPrice = 0;
        let upsells = false;
        for (let i = 0; i < props.myCart.length; i++) {
          const element = props.myCart[i];
          if (element.cartType == "upsells") {
            totalPrice = totalPrice + parseInt(element.cartPrice);
            let cartAmount = parseInt(element.cartPrice);
            let cartPr = (cartAmount / 100) * 30;
            let cartProfit = cartAmount - cartPr;
            props.myCart[i].profit = cartProfit;
            benifit = benifit + cartPr;
          } else {
            totalPrice = totalPrice + parseInt(element.cartPrice);
            if (element.profit != null) {
              props.myCart[i].profit = 0;
            }
          }
        }
        setMainTotal(totalPrice);
        Cookies.set("mainPrice", totalPrice);
        Cookies.set("cart", props.myCart);
        Cookies.set("discount", benifit);
        let mainPrice = totalPrice - benifit;
        Cookies.set("totalPrice", mainPrice);
        props.setPrice(mainPrice);
      }
    }
  };
  let femaleTests = ["Female Hormone Complete", "Female Hormone Standard"];
  let maleTests = ["Male Hormone Complete", "Male Hormone Standard"];

  const checkIfMale = () => {
    let setMale = false;
    props.myCart.map((item) => {
      if (maleTests.indexOf(item.cartName) != -1) {
        setMale = true;
      }
    });
    return setMale;
  };
  const checkIfFemale = () => {
    let setFemale = false;
    props.myCart.map((item) => {
      if (femaleTests.indexOf(item.cartName) != -1) {
        setFemale = true;
      }
    });
    return setFemale;
  };

  const hideUpsellsSection = () => {
    let itemsInCart = props.myCart.map((item) => {
      return item.cartName;
    });
    let crossSellToShow = [];
    let firstItemInCart = props.myCart[0];
    let upsellsToShow =
      firstItemInCart != undefined &&
      upsellData.find((itm) => itm.test == firstItemInCart.cartName);
    if (upsellsToShow) {
      upsellsToShow.Upsells.map((item) => {
        if (itemsInCart.indexOf(item.cartName) != -1) {
        } else {
          crossSellToShow.push(item.cartName);
        }
      });
    }
    let isMale = checkIfMale();
    let isFemale = checkIfFemale();
    if (isMale) {
      crossSellToShow = crossSellToShow.filter(
        (el) => !femaleTests.includes(el)
      );
    }
    if (isFemale) {
      crossSellToShow = crossSellToShow.filter((el) => !maleTests.includes(el));
    }
    return crossSellToShow.length;
  };
  const addCrossSells = (cart) => {
    props.myCart.push(cart);
    Cookies.set("cart", props.myCart);
    props.setPrice(parseInt(props.price) + parseInt(cart.cartPrice));
    let calculate_price = parseInt(cart.cartPrice) + parseInt(props.price);
    Cookies.set("totalPrice", calculate_price);
  };

  const addUpsellsToCart = (cart) => {
    setActiveIndex((activeIndex) => {
      return {
        ...activeIndex,
        val: cart.cartName,
      };
    });
    let findTest = props.myCart.find((x) => x.cartName == cart.cartName);
    if (findTest) {
      props.setCloseCart(false);
      FreshworksWidget("show");
      swal("Please choose another test you have already selected this test.");
    } else {
      props.myCart.push(cart);
      let totalPrice = 0;
      let benifit = 0;
      for (let i = 0; i < props.myCart.length; i++) {
        const element = props.myCart[i];
        if (element.cartType == "upsells") {
          totalPrice = totalPrice + parseInt(element.cartPrice);
          let cartAmount = parseInt(element.cartPrice);
          let cartPr = (cartAmount / 100) * 30;
          let cartProfit = cartAmount - cartPr;
          props.myCart[i].profit = cartProfit;
          benifit = benifit + cartPr;
        } else {
          totalPrice = totalPrice + parseInt(element.cartPrice);
          if (element.profit != null) {
            props.myCart[i].profit = 0;
          }
        }
      }
      setMainTotal(totalPrice);
      Cookies.set("mainPrice", totalPrice);
      Cookies.set("cart", props.myCart);
      Cookies.set("discount", benifit);
      let mainPrice = totalPrice - benifit;
      Cookies.set("totalPrice", mainPrice);
      props.setPrice(mainPrice);
    }
  };
  let [oldLabFee, setOldLabFee] = useState(null);
  useEffect(() => {
    if (props.myCart && props.myCart.length > 0) {
      let setVal = hideUpsellsSection();
      if (setVal == 0) {
        setShowCrossSell(false);
      } else {
        setShowCrossSell(true);
      }
    }
  }, [props.myCart.length]);

  const tests = [
    {
      testName: "STD Basic",
    },
    {
      testName: "STD Standard",
    },
    {
      testName: "STD Complete",
    },
  ];
  // useEffect(() => {
  //   props.myCart[0].month = 12;
  // }, []);
  const [plan, setPlan] = useState(21);
  const changePlan = (ele, key) => {
    setPlan(key);
    let price12 = parseInt(props.price);
    let price13 = price12 - parseInt(props.myCart[0].cartPrice);
    props.myCart[0].cartPrice = parseInt(ele.month.insurance.price);
    props.myCart[0].key = ele.month.insurance.key;
    props.setPrice(price13 + parseInt(ele.month.insurance.price));
    let cd = price13 + parseInt(ele.month.insurance.price);
    if (ele.month.val == "1") {
      props.myCart[0].monthText = " " + "/" + " " + "month";
    } else {
      props.myCart[0].monthText =
        " " + "/" + " " + ele.month.val + " " + "months";
    }
    if (mainTotal != undefined) {
      let loltotal = 0;
      for (let i = 0; i < props.myCart.length; i++) {
        const element = props.myCart[i];
        loltotal = parseInt(loltotal) + parseInt(element.cartPrice);
      }
      setMainTotal(loltotal);
      Cookies.set("mainPrice", loltotal);
    }
    Cookies.set("totalPrice", cd);
    Cookies.set("cart", props.myCart);
    Cookies.set("subscription", ele);
  };
  const changeOneTimePlan = () => {
    setPlan(21);
    let price12 = parseInt(props.price);
    let price13 = price12 - parseInt(props.myCart[0].cartPrice);
    props.myCart[0].cartPrice = parseInt(test.price);
    props.myCart[0].key = null;
    props.myCart[0].monthText = null;
    props.setPrice(price13 + parseInt(test.price));
    let cd = price13 + parseInt(test.price);
    Cookies.set("totalPrice", cd);
    Cookies.set("cart", props.myCart);
    Cookies.remove("subscription");
    if (mainTotal != undefined) {
      let loltotal = 0;
      for (let i = 0; i < props.myCart.length; i++) {
        const element = props.myCart[i];
        loltotal = parseInt(loltotal) + parseInt(element.cartPrice);
      }
      setMainTotal(loltotal);
      Cookies.set("mainPrice", loltotal);
    }
  };
  const gotToCheckout = () => {
    if (
      props.myCart.length == 1 &&
      (props.myCart[0].cartName == "STD Standard" ||
        props.myCart[0].cartName == "STD Complete")
    ) {
      let stdData = {
        cartImg: "/chlamydia_&_gonorrhea.gif",
        cartName: "STD Basic",
        labFee: 100,
        cartPrice: 129,
      };
      Cookies.set("stdBasic", stdData);
    } else {
      Cookies.remove("stdBasic");
    }
    let findUpsells = props.myCart.find((x) => x && x.type == "upsells");
    if (!findUpsells) {
      Cookies.remove("discount");
    }
    Cookies.set("cart", props.myCart);
    if (props.myCart.length > 0) {
      Cookies.set("testImg", props.myCart[0].testImg);
      Cookies.set("isInsurance", props.insurance);
      router.push("/checkout");
    } else {
      swal("Please add a test for checkout");
      props.setCloseCart(false);
      FreshworksWidget("show");
      Cookies.remove("totalPrice", { path: "" });
      Cookies.remove("cart", { path: "" });
    }
  };


  return (
    <>
      {props.closeCart == true ? (
        <div className="awaam">
          <div className="sidebar cart-sidebar">
            <div className="cart-header px-3 position-relative">
              <h2 className="mb-3 cart-head">My Cart</h2>
              <span
                className="close-cart"
                style={{ cursor: "pointer" }}
                onClick={(e) => closeCart()}
              >
                <i className="fa fa-times delete-icon" aria-hidden="true"></i>
              </span>
            </div>
            <div></div>
            <div className={"card-main-wrapper-weightloss"}>
              {props && props.myCart && props.myCart.length > 0
                ? props.myCart.map((ele, key) => (
                  <div className="cart-main position-relative" key={key}>
                    <div className="cart-items">
                      <div className="cart-img">
                        <Image cloudName={'ddvckq469'} publicId={ele.testImg} loading="lazy" />
                      </div>
                      <div className="card-first-row d-flex justify-content-between">
                        <div className="cart-content">
                          {props.type2 != null &&
                            ele.cartName == "Bupropion Weight Loss Program" ? (
                            <h2 className="mb-0 text-capitalize">
                              {props.type2} Weight Loss Program
                            </h2>
                          ) : (
                            <>

                              {props.dki == "diet_pills" ?
                                <>
                                  {ele.cartName == "Bupropion Weight Loss Program" ? <h2 className="mb-0">Weight Loss Basic</h2> :
                                    <>{ele.cartName ==
                                      "GLP-1 Weight Loss Program" ? <h2 className="mb-0">Weight Loss Standard</h2> : <h2 className="mb-0">Weight Loss Complete</h2>}</>}

                                </>
                                : <>
                                  {props.type != null &&
                                    ele.cartName != "Bupropion Weight Loss Program" && ele.cartType == "weightloss" ? (
                                    <>
                                      {ele.cartName ==
                                        "GLP-1 Weight Loss Program" ? (
                                        <h2 className="mb-0 text-capitalize">
                                          {props.type} Weight Loss Program
                                        </h2>
                                      ) : (
                                        <h2 className="mb-0 text-capitalize">
                                          {props.type} Weight Loss Complete Program
                                        </h2>
                                      )}
                                    </>
                                  ) : (
                                    <>
                                      {ele.cartType == "weightloss" &&
                                        props.shopping ? (
                                        <h2 className="mb-0">
                                          {ele.cartName.split(" Program")[0]}
                                        </h2>
                                      ) : (
                                        <h2 className="mb-0">{ele.cartName}</h2>
                                      )}
                                    </>
                                  )}
                                </>

                              }
                            </>
                          )}
                        </div>
                        {/* <p className="mb-2">The two most common STD's.</p> */}
                        <div className="price profit-price text-right pb-0 mb-0">
                          <p className={"mb-2 cross"}>
                            {ele && ele.profit ? (
                              <>
                                {ele && ele.show_price ?
                                  <span className="f-price text-mint pr-2">
                                    ${parseInt(ele.show_price).toFixed(2)}
                                  </span> :
                                  <span className="f-price text-mint pr-2">
                                    ${ele.cartPrice}
                                    {props.variant == "insurance" &&
                                      key == 0 &&
                                      " + Insurance"}
                                  </span>}
                              </>
                            ) : (
                              ""
                            )}
                          </p>
                          {ele && ele.profit ? (
                            <>
                              {ele && ele.show_price ?
                                <span className="f-price text-mint pr-2">
                                  ${parseInt(ele.show_price).toFixed(2)}
                                </span> :
                                <span className="f-price f-p1 text-mint pr-2">
                                  ${parseInt(ele.profit).toFixed(2)}
                                </span>}
                            </>
                          ) : (
                            <>
                              {ele && ele.show_price ?
                                <span className="f-price text-mint pr-2">
                                  ${parseInt(ele.show_price).toFixed(2)}
                                </span> :
                                <span className="f-price text-mint pr-2">
                                  ${parseInt(ele.cartPrice).toFixed(2)}
                                  {props.variant == "insurance" &&
                                    key == 0 &&
                                    " + Insurance"}
                                </span>}</>
                          )}

                        </div>
                      </div>
                    </div>

                    <div
                      className="delete-item"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => deleteUpsells(ele)}
                    >
                      <i className="fa fa-trash-o" aria-hidden="true"></i>
                    </div>
                  </div>
                ))
                : ""}
            </div>
            <>
              {props.myCart[0].cartType == "weightloss" ? (
                <CrossSells
                  myCart={props.myCart}
                  addCrossSells={addCrossSells}
                  upsell={upsell}
                  showDiscountPrice={showDiscountPrice}
                />
              ) : (
                <>
                  {data.length > 0 &&
                    props.myCart.find((x) => x.cartType == "weightloss") ===
                    undefined && (
                      <div className="row d-flex justify-content-center p-3">
                        <p className="f-left upsell-head">
                          Choose your subscription
                        </p>
                        <div className={`row ${isMobile == true && ""}`}>
                          {data.map((ele, key) => (
                            <div
                              className={`col-md-4 col-4 ${isMobile == true && key == 2 ? "mt-4" : "mt-2"
                                }`}
                              key={key}
                              style={{ cursor: "pointer" }}
                              onClick={(e) => {
                                changePlan(ele, key);
                              }}
                            >

                              <div
                                className={`${key == plan && "card-selected"
                                  } main-body`}
                              >
                                {/* {key == 21 && (
                                  <span className="label-weightloss-cart">
                                    BEST VALUE
                                  </span>
                                )} */}

                                <div className="card-body text-center d-block">
                                  <p className="plan-test">
                                    {ele.month.insurance.text.split(":")[0]}:
                                  </p>
                                  <p className="plan-test">
                                    {ele.month.insurance.text.split(":")[1]}
                                  </p>
                                </div>
                              </div>
                            </div>
                          ))}

                          <div
                            className={"col-md-4  col-4 mt-2"}
                            style={{ cursor: "pointer" }}
                            onClick={(e) => {
                              changeOneTimePlan();
                            }}
                          >
                            <div
                              className={`${plan == 21 && "card-selected"
                                } main-body`}
                            >
                              <span className="label-weightloss-cart">
                                BEST VALUE
                              </span>
                              <div className="card-body text-center d-block">
                                <p className="plan-test">One Time Purchase</p>
                                <p className="plan-test">${test?.price}</p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                </>
              )}
              {props.myCart[0].cartType != "weightloss" && (
                <CrossSells
                  myCart={props.myCart}
                  addCrossSells={addCrossSells}
                  upsell={upsell}
                  showDiscountPrice={showDiscountPrice}
                />
              )}
            </>
            {showCrossSell == true && (
              <div className="cart-upsells-section">
                <div className="px-3 text-center py-3">
                  <p className="f-left upsell-head">Buy together and save<small className='see_details_main3 star-disclmair'> *</small>
              <ul className='see_details_p3 together-view'>
                <li>Lab testing billed separately. Costs shown are for lab order, if eligible.
                </li>
              </ul></p>
                  <div className="hhh " id="style2">
                    <div className="row gx-2 flex-nowrap">
                      {props.myCart[0].cartName ==
                        "GLP-1 Weight Loss Program" && (
                          <div className="col-md-5 col-8">
                            <div className="card card-main  card-main-2 text-start">
                              <CloudinaryContext cloudName={'ddvckq469'}>
                                <Image className=" pb-1 text-start d-block ml-auto mb-2" publicId='v1678202051/NextMed/GLP_-_1_owkxqe.png' loading="lazy" />
                              </CloudinaryContext>
                              <div className="d-flex justify-content-between">
                                {props.dki != "diet_pills" ?
                                  <small className="pb-2 upsells-title d-block">
                                    GLP-1 Weight Loss Complete Program
                                  </small> :
                                  <small className="pb-2 upsells-title d-block">
                                    Weight Loss Complete
                                  </small>}
                                <small className="pb-2 upsells-price-norm d-block">
                                  +$50/month
                                </small>
                              </div>
                              <div className="card-bottom-btn ">
                                <small className="text-mute">
                                  Add Apple Fitness+ and quarterly hormone testing
                                  for only $50 more per month.
                                </small>
                                <p className="text-success  save-30">
                                  Maximize your weight loss
                                </p>
                                <span className="text-secondary you-save d-block mb-2"></span>
                                <button
                                  type="button"
                                  className="btn  rounded-2 button-colr"
                                  id="add-upsell-button"
                                  onClick={(e) => {
                                    upgradeTest({
                                      img: "/wegovy.webp",
                                      cartName:
                                        "GLP-1 Weight Loss Complete Program",
                                      type: "weightloss",

                                      cartPrice: props.variant == "dec" ? 48 : 99,
                                      weightlossKey: "price_1LccqWDM8fNsPiHloFfBaTCf",
                                      month: 1,
                                    });
                                  }}
                                >
                                  <span>Upgrade</span>{" "}
                                </button>{" "}
                              </div>
                            </div>
                          </div>
                        )}
                      {props.myCart[0].cartName == "Bupropion Weight Loss Program" && (
                        <div className="col-md-5 col-8">
                          <div className="card card-main  card-main-2 text-start">
                            <CloudinaryContext cloudName={'ddvckq469'}>
                              <Image className=" pb-1 text-start d-block ml-auto mb-2" publicId='v1678202051/NextMed/GLP_-_1_owkxqe.png' loading="lazy" />
                            </CloudinaryContext>
                            <div className="d-flex justify-content-between">
                              <small className="pb-2 upsells-title d-block">
                                Bupropion™ Weight Loss Complete Program
                              </small>
                              <small className="pb-2 upsells-price-norm d-block">
                                +$50/month
                              </small>
                            </div>
                            <div className="card-bottom-btn ">
                              <small className="text-mute">
                                Add Apple Fitness+ and quarterly hormone testing
                                for only $89  for first month.
                              </small>
                              <p className="text-success  save-30">
                                Maximize your weight loss
                              </p>
                              <span className="text-secondary you-save d-block mb-2"></span>
                              <button
                                type="button"
                                className="btn  rounded-2 button-colr"
                                id="add-upsell-button"
                                onClick={(e) => {
                                  upgradeTest({
                                    img: "/upsells/vitamin.webp",
                                    cartName:
                                      "Bupropion Weight Loss Complete Program",
                                    type: "weightloss",
                                    cartPrice: props.variant == "dec" ? 48 : 89,
                                    weightlossKey:
                                      "price_1Ljn7xDM8fNsPiHlK306uID4",
                                    month: 1,
                                  });
                                }}
                              >
                                <span>Upgrade</span>{" "}
                              </button>{" "}
                            </div>
                          </div>
                        </div>
                      )}
                      {upsell?.Upsells.map((element, key) =>
                        props.myCart.find(
                          (x) => x.cartName == element.cartName
                        ) != undefined ||
                          (props.myCart.find(
                            (x) =>
                              x.cartName == "Male Hormone Complete" ||
                              x.cartName == "Male Hormone Standard"
                          ) != undefined &&
                            element.cartName == "Female Hormone Complete") ||
                          element.cartName == "Female Hormone Standard" ||
                          (props.myCart.find(
                            (x) =>
                              x.cartName == "Female Hormone Complete" ||
                              x.cartName == "Female Hormone Standard"
                          ) != undefined &&
                            element.cartName == "Male Hormone Complete") ||
                          element.cartName == "Male Hormone Standard" ? (
                          ""
                        ) : (
                          <div className="col-md-5 col-8" key={key}>
                            <div className="card card-main card-back-color  card-main-2 text-start">
                              <CloudinaryContext cloudName={'ddvckq469'}>
                                <Image className=" pb-1 text-start d-block ml-auto mb-2" publicId={element.testImg} loading="lazy" />
                              </CloudinaryContext>
                              <div className="d-flex justify-content-between">
                                <small className="pb-2 upsells-title d-block">
                                  {element.cartName}
                                </small>
                                {element && element.plus ? (
                                  <small className="pb-2 upsells-price-norm  d-block">
                                    +${element.plus}test
                                  </small>
                                ) : (props.myCart.length > 0 &&
                                  props.myCart[0].cartName == "STD Basic" &&
                                  element.cartName == "STD Standard") ||
                                  (props.myCart.length > 0 &&
                                    props.myCart[0].cartName == "STD Standard" &&
                                    element.cartName == "STD Complete") ||
                                  (props.myCart.length > 0 &&
                                    props.myCart[0].cartName ==
                                    "48 Hour RT-PCR" &&
                                    element.cartName == "24 Hour RT-PCR") ||
                                  (props.myCart.length > 0 &&
                                    props.myCart[0].cartName ==
                                    "Thyroid Standard Panel" &&
                                    element.cartName ==
                                    "Thyroid Complete Panel") ||
                                  (props.myCart.length > 0 &&
                                    props.myCart[0].cartName ==
                                    "Thyroid Function Test" &&
                                    element.cartName ==
                                    "Thyroid Standard Panel") ||
                                  (props.myCart.length > 0 &&
                                    props.myCart[0].cartName == "Cortisol Test" &&
                                    element.cartName ==
                                    "Sleep & Stress Hormone Test") ? (
                                  <div className="price-upsells">
                                    <small className="pb-2 cart-price-item">
                                      ${element.cartPrice - showDiscountPrice(element) - 1}
                                    </small>
                                    <small className="pb-2 upsells-price-norm d-block">
                                      ${element.cartPrice}
                                    </small>
                                  </div>
                                ) : (

                                  <div className="price-upsells">
                                    <small className="pb-2 cart-price-item">
                                      ${element.cartPrice - showDiscountPrice(element) - 1}
                                    </small>
                                    <small className="pb-2 upsells-price-norm upsells-price d-block">
                                      ${element.cartPrice}
                                    </small>
                                  </div>
                                )}
                              </div>

                              <div className="card-bottom-btn ">
                                <small className="text-mute">
                                  {element.text}
                                </small>
                                {props.myCart.length > 0 &&
                                  props.myCart[0].cartType == "allergy" &&
                                  (element.cartName == "Indoor & Outdoor Allergy" ||
                                    element.cartName == "36 Food Allergy Panel" ||
                                    element.cartName == "Celiac Complete" ||
                                    element.cartName ==
                                    "Indoor and Outdoor Allergy") ? (
                                  <>
                                    <p className="text-success  save-30">
                                      Get 30% off.
                                    </p>{" "}
                                    {props.myCart.find(
                                      (x) => x.cartName == element.cartName
                                    ) == undefined ? (
                                      <span className="text-secondary you-save d-block mb-2">
                                        You Save ${showDiscountPrice(element) - 1}
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {(props.myCart.length > 0 &&
                                      props.myCart[0].cartName == "STD Basic" &&
                                      element.cartName == "STD Standard") ||
                                      (props.myCart.length > 0 &&
                                        props.myCart[0].cartName ==
                                        "STD Standard" &&
                                        element.cartName == "STD Complete") ||
                                      (props.myCart.length > 0 &&
                                        props.myCart[0].cartName ==
                                        "48 Hour RT-PCR" &&
                                        element.cartName == "24 Hour RT-PCR") ||
                                      (props.myCart.length > 0 &&
                                        props.myCart[0].cartName ==
                                        "Thyroid Standard Panel" &&
                                        element.cartName ==
                                        "Thyroid Complete Panel") ||
                                      (props.myCart.length > 0 &&
                                        props.myCart[0].cartName ==
                                        "Thyroid Function Test" &&
                                        element.cartName ==
                                        "Thyroid Standard Panel") ||
                                      (props.myCart.length > 0 &&
                                        props.myCart[0].cartName ==
                                        "Cortisol Test" &&
                                        element.cartName ==
                                        "Sleep & Stress Hormone Test") ? (
                                      ""
                                    ) : (
                                      <>
                                        <p className="text-success  save-30">
                                          {element.save}
                                        </p>
                                        {props.myCart.find(
                                          (x) => x.cartName == element.cartName
                                        ) == undefined ? (
                                          <span className="text-secondary you-save d-block mb-2">
                                            You Save ${showDiscountPrice(element) - 1}
                                          </span>
                                        ) : (
                                          ""
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                                <button
                                  type="button"
                                  id="add-upsell-button"
                                  className={
                                    (props.myCart.length > 0 &&
                                      props.myCart[0].cartName == "STD Basic" &&
                                      element.cartName == "STD Standard") ||
                                      (props.myCart.length > 0 &&
                                        props.myCart[0].cartName ==
                                        "STD Standard" &&
                                        element.cartName == "STD Complete") ||
                                      (props.myCart.length > 0 &&
                                        props.myCart[0].cartName ==
                                        "48 Hour RT-PCR" &&
                                        element.cartName == "24 Hour RT-PCR") ||
                                      (props.myCart.length > 0 &&
                                        props.myCart[0].cartName ==
                                        "Thyroid Standard Panel" &&
                                        element.cartName ==
                                        "Thyroid Complete Panel") ||
                                      (props.myCart.length > 0 &&
                                        props.myCart[0].cartName ==
                                        "Thyroid Function Test" &&
                                        element.cartName ==
                                        "Thyroid Standard Panel") ||
                                      (props.myCart.length > 0 &&
                                        props.myCart[0].cartName ==
                                        "Cortisol Test" &&
                                        element.cartName ==
                                        "Sleep & Stress Hormone Test")
                                      ? "btn rounded-2 button-position button-colr"
                                      : "btn  rounded-2 button-colr"
                                  }
                                  onClick={(e) =>
                                    addUpsellsToCart({
                                      cartName: element.cartName,
                                      cartPrice: element.cartPrice,
                                      cartType: element.cartType,
                                      testImg: element.cartImg,
                                      type: element.type,
                                    })
                                  }
                                >
                                  {element && element.plus ? (
                                    <span>Upgrade</span>
                                  ) : (
                                    <span>Add to cart</span>
                                  )}{" "}
                                </button>{" "}
                              </div>
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}


            <div
              className={
                props.myCart.find((x) => x.cartType == "weightloss") == undefined
                  ? "action-btn"
                  : "action-plus-btn"
              }
            >
              {props.myCart.find((x) => x.cartType == "weightloss") ==
                undefined && (
                  <div className="subtotal">
                    <div className="d-block pr-3">
                      <span className="d-block text-uppercase subtotal-text">
                        Subtotal
                      </span>
                      {mainTotal != undefined ? (
                        <small className="upsells-price-norm upsells-price d-block">
                          ${parseInt(mainTotal).toFixed(2)}
                        </small>
                      ) : (
                        ""
                      )}
                      <span className="fwb f-20 final-price">
                        ${parseInt(props.price).toFixed(2)}
                      </span>
                    </div>
                  </div>
                )}
              <div
                className={
                  props.myCart.find((x) => x.cartType == "weightloss") ==
                    undefined
                    ? "continue-checkout"
                    : "continue-plus-checkout"
                }
                style={{ cursor: "pointer" }}
                onClick={(e) => {
                  gotToCheckout();
                }}
              >
                <button
                  type="button"
                  className={
                    "btn btn-primary btn-lg checkout_button custom-btn-id " +
                    props.btnColor
                  }
                  id="goto-checkout-button"
                >
                  <i className="fa fa-lock"></i> Continue to Checkout
                </button>

              </div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
};
// FreshworksWidget("hide");
export default CartBar1;